import React from 'react'
import Select, { type ControlProps, type GroupBase, type ValueContainerProps } from 'react-select'

import { getTranslate } from '../../utilities/i18n'
import { type FilterSlug } from './filters.interface'
import useFilters from './hooks/useFilters'
// see https://react-select.com/typescript#custom-select-props
import type {} from 'react-select/base'

import { TherapistFilterMenuTriggerUI } from '@/src/domains/therapist-filters/components/TherapistFilterMenuTrigger'

type Props = { slug: FilterSlug; options: any; icon?: string }

export const CustomValueContainer = ({ children }: ValueContainerProps) => {
  return <span className="text-align-left flex flex-row justify-start overflow-hidden">{children}</span>
}

export const DisableRender = () => null

export const CustomControl = ({
  children,
  innerRef,
  innerProps,
  menuIsOpen,
  selectProps,
  isDisabled,
}: ControlProps) => (
  <TherapistFilterMenuTriggerUI
    // @ts-expect-error it is OK to use a div ref here
    ref={innerRef}
    {...innerProps}
    disabled={isDisabled}
    icon={selectProps.icon ?? ''}
    data-state={menuIsOpen ? 'open' : 'closed'}
  >
    {children}
  </TherapistFilterMenuTriggerUI>
)

const Filter: React.FC<Props> = ({ slug, options, icon }) => {
  const { t } = getTranslate()
  const { setFilters, getFilterValue } = useFilters()

  const filterValues = getFilterValue(slug)
  const value = options.filter((option) => filterValues.includes('' + option.value))

  const handleOnChange = (newValue) => {
    setFilters([{ slug, value: newValue.map((item) => item.value) }])
  }

  return (
    <Select
      closeMenuOnSelect={false}
      // needed on iOS to prevent closing on select
      // https://stackoverflow.com/questions/65036191/react-select-component-closemenuonselect-false-still-closing
      blurInputOnSelect={false}
      className="react-select !max-w-none"
      classNamePrefix="react-select"
      isMulti
      isSearchable={false}
      isClearable={false}
      onChange={handleOnChange}
      options={options}
      placeholder={t(`components.filter.${slug}.title`)}
      controlShouldRenderValue={false}
      icon={icon}
      hideSelectedOptions={false}
      value={value}
      components={{
        ValueContainer: CustomValueContainer,
        Control: CustomControl,
        IndicatorsContainer: DisableRender,
      }}
    />
  )
}

// see https://react-select.com/typescript#custom-select-props
declare module 'react-select/base' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export interface Props<Option, IsMulti extends boolean, Group extends GroupBase<Option>> {
    text?: string
    icon?: string
  }
}

export default Filter
